import { HomeContext } from './HomeContext'
import { useEffect, useMemo, useState, useContext } from 'react'
import { sweetError } from '@/utils/sweetalert2'
import { membershipsAsync } from '@/services/axios/guest/general'
import { AuthContext } from '@/context/AuthContext'

export const HomeProvider = ({ children }) => {
  const [subscriptions, setSubscriptions] = useState([])

  const { onSubmit } = useContext(AuthContext)
  useEffect(() => {
    const getCountrySelection = async () => {
      try {
        const { data: { records } } = await membershipsAsync(() => onSubmit.onLogOut())
        setSubscriptions(
          records
        )
      } catch (e) {
        sweetError('', e)
      }
    }
    getCountrySelection()
  }, [])

  const props = useMemo(() => ({
    subscriptions
  }), [subscriptions])

  return (
    <HomeContext.Provider value={props}>
      {children}
    </HomeContext.Provider>
  )
}
